import { getBaseRoute, isValidEnv, ValidEnv } from '@aline/common';
import { routes } from '@aline/routes';
import { disableFragmentWarnings } from '@apollo/client';
import { LicenseInfo } from '@mui/x-license';

/**
 * Disables unneeded warning: "fragment with name [_] already exists."
 * See: https://github.com/apollographql/graphql-tag#warnings
 */
disableFragmentWarnings();

/**
 * NOTE: Make sure to set the environment variable(s) in the vite config if you want it available on the client.
 */
const ENV = process.env.ENV || ValidEnv.dev;

if (!isValidEnv(ENV))
  throw new Error(
    `Invalid ENV: ${ENV}. Must be be set to one of [${Object.values(ValidEnv).join(',')}]`
  );

export const env: ValidEnv = ENV;
export const debugLogs: boolean = env === 'dev';
export const collabPort: string = process.env.COLLAB_PORT || '1234';
export const docuSignIntegrationKey: string = process.env.DOCUSIGN_INTEGRATION_KEY || '';
export const docuSignRedirectUri: string = process.env.DOCUSIGN_REDIRECT_URI || '';
export const filestackApiKey: string = process.env.FILESTACK_API_KEY || 'fake-key';
export const materialUIXKey: string = process.env.MATERIAL_UI_X_KEY2 || '';
export const apryseWebViewerVersion: string = process.env.APRYSE_WEBVIEWER_VERSION || '';
export const pdfTronKey: string = process.env.PDFTRON_KEY || '';
export const releaseDate: string = process.env.RELEASE_DATE || Date();
export const releaseTag: string = process.env.RELEASE_TAG || '';
export const intercomAppId = 'hxutwuf0';
export const isCI: boolean = env === 'ci';
export const isDev: boolean = env === 'dev';
export const isProd: boolean = env === 'production';
export const isStaging: boolean = env === 'staging';

/**
 * In local dev, use the browser origin so tunnels (e.g. ngrok) match API and auth redirects.
 * Otherwise GraphQL and copied links would still point at localhost:3030.
 */
export function getClientPublicOrigin() {
  if (isDev && typeof window !== 'undefined') return window.location.origin;
  return getBaseRoute(env);
}
export const SENTRY_DERIVED_DSN: string = process.env.SENTRY_DERIVED_DSN || '';
export const sentryClientSampleRate = Number(process.env.SENTRY_CLIENT_SAMPLE_RATE || '1');
export const salesEmail = 'sales@aline.co';
export const supportEmail = 'support@aline.co';
export const homePageRoute = 'https://aline.co';
export const docsRoute = 'https://docs.aline.co';
const websocketProtocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
// TODO: Remove this when nginx.conf is fixed to allow `/collab*` to be passed through to the collab service.
const collabHost =
  isDev || isCI ? window.location.hostname + `:${collabPort}` : window.location.host;
export const collabEndpoint: string = websocketProtocol + collabHost + routes.CollabDocumentIndex;
export const subscriptionsEndpoint =
  websocketProtocol + window.location.host + routes.Subscriptions;

// Set Material-UI-X License Info
LicenseInfo.setLicenseKey(materialUIXKey);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any)._aline = { releaseDate, releaseTag };

/**
 * Intercom product tour ids.
 */
export const IntercomTour = {
  alineAIExampleReport: 606665,
  alineOverview: 405654,
  dismissGetStartedAlert: 488752,
  generateAiPlaybook: 606663,
  launchExampleNDA: 486040,
  signPDF: 486549,
  uploadDocument: 606649,
};
